
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "LaboratoryExaminationItemsAndResultsOfThyroidFunctionDuringPregnancy",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/LaboratoryExaminationItemsAndResultsOfThyroidFunctionDuringPregnancy.vue